class deliveryEstimates extends HTMLElement {
    constructor() {
        super();
        const countryCodeSelect =  Shopify.country;
        const
            minDateUSA = 1, maxDateUSA = 3,
            minDateJapan = 2, maxDateJapan = 5,
            minDateKorea = 2, maxDataKorea = 4,
            minDateMexico = 3, maxDateMexico = 5,
            minDateSpainPortugal = 1, maxDateSpainPortugal = 1,
            minDateEurope = 1, maxDateEurope = 2,
            minDateOther = 2, maxDateOther = 5;

        let countryEurope = [
            "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
            "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
            "PL", "PT", "RO", "SK", "SI", "ES", "SE", "AL", "AD", "BY",
            "BA", "IS", "XK", "LI", "MD", "MC", "ME", "MK", "NO", "RU",
            "SM", "RS", "CH", "UA"];

        let countryCodeUsa = ['US'];
        let countryJapan = ['JP'];
        let countryKorea = ['KR'];
        let countryMexico = ['MX'];
        let countrySpainPortugal= ['ES', 'PT']

        let minDateShipping, maxDateShipping,timeShipping, minShipDate = minDateOther, maxShipDate = maxDateOther;

        minShipDate = minDateOther;
        maxShipDate = maxDateOther;
        if(countryCodeUsa.includes(countryCodeSelect)) {
            minShipDate = minDateUSA;
            maxShipDate = maxDateUSA;
        } else if (countryJapan.includes(countryCodeSelect)) {
            minShipDate = minDateJapan;
            maxShipDate = maxDateJapan;
        } else if (countryKorea.includes(countryCodeSelect)) {
            minShipDate = minDateKorea;
            maxShipDate = maxDataKorea;
        } else if (countryMexico.includes(countryCodeSelect)) {
            minShipDate = minDateMexico;
            maxShipDate = maxDateMexico;
        } else if (countrySpainPortugal.includes(countryCodeSelect)) {
            minShipDate = minDateSpainPortugal;
            maxShipDate = maxDateSpainPortugal;
        } else if (countryEurope.includes(countryCodeSelect)) {
            minShipDate = minDateEurope;
            maxShipDate = maxDateEurope;
        }

        minDateShipping = this.makeDeliveryCalculator(minShipDate, countryCodeSelect);
        maxDateShipping = this.makeDeliveryCalculator(maxShipDate, countryCodeSelect);

        let monthMin = this.convertMonth(this,minDateShipping.month);
        let monthMax = this.convertMonth(this,maxDateShipping.month);

        if(monthMin !== monthMax) {
            timeShipping = this.convertMessDelivery(this,'mess-shipping1', minDateShipping.day, maxDateShipping.day, monthMin, monthMax);
        }
        else if(monthMin === monthMax && minDateShipping.day === maxDateShipping.day) {
            timeShipping = this.convertMessDelivery(this,'mess-shipping2', minDateShipping.day, null,  monthMin, null);
        } else {
            timeShipping = this.convertMessDelivery(this,'mess-shipping', minDateShipping.day, maxDateShipping.day, monthMax, null);
        }
        this.querySelector('.text-date-delivery').innerHTML = timeShipping;
    }

    convertMessDelivery(self, mess, day1, day2, month1, month2) {
        let textDelivery = self.getAttribute(`data-${mess}`);
        if(day1 && textDelivery.search('{{day1}}') > -1) {
            textDelivery = textDelivery.replaceAll('{{day1}}', day1);
        }
        if(day2 && textDelivery.search('{{day2}}') > -1) {
            textDelivery = textDelivery.replaceAll('{{day2}}', day2);
        }
        if(month1 && textDelivery.search('{{month1}}') > -1) {
            textDelivery = textDelivery.replaceAll('{{month1}}', month1);
        }
        if(month2 && textDelivery.search('{{month2}}') > -1) {
            textDelivery = textDelivery.replaceAll('{{month2}}', month2);
        }
        return textDelivery;
    }

    convertMonth(self, moth) {
        return self.getAttribute(`data-${moth}`);
    }

    makeDeliveryCalculator(ndays, countryCodeSelect) {
        let  cutOffTime = '16:00', excludeDaysOfWeek = [0, 6], holidays = [];

        let nowInSpain = new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" });
        let now = new Date(nowInSpain);

        holidays = JSON.parse(localStorage.getItem('holidays') || '[]');
        console.log('script holidays', holidays)
        if(countryCodeSelect == "ES") {
            cutOffTime = '18:00';
        }
        let [cutOffHours, cutOffMinutes] = cutOffTime.split(/:/)
        let cutOffDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutOffHours, cutOffMinutes, 0, 0);

        // if cut-off time passed, add one day
        const n = ndays + (now > cutOffDate ? 1 : 0);

        const formatter = new Intl.DateTimeFormat('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });

        const today = new Date(now)
        today.setHours(0, 0, 0, 0)

        let deliveryOn = new Date(today)

        let i = 0
        while (true) {
            // let yyyymmdd = formatter.format(deliveryOn)

            let dayMonth = `${deliveryOn.getDate()}/${deliveryOn.getMonth() + 1}`;

            let canDelivery = !excludeDaysOfWeek.includes(deliveryOn.getDay()) &&
                !holidays.some(pattern => dayMonth.endsWith(pattern))

            if (canDelivery) {
                if (i++ === n) {
                    break
                }
            }
            deliveryOn.setDate(deliveryOn.getDate() + 1)
        }

        let month = deliveryOn.toLocaleString('en', { month: 'long' });

        return {
            day: deliveryOn.getDate(),
            month: month
        }
    }
}
customElements.define('automatic-delivery-estimates', deliveryEstimates)